import { cn } from "~/lib/utils";
import * as React from "react";
import { FilterMetadata } from "../../types";
import { useDebouncedState } from "~/utils/useDebouncedInput";
import { Input } from "~/components/ui/input";
import { PercentIcon } from "lucide-react";

// // // //

interface Props {
    value: number;
    onChange: (updatedValue: number) => void;
    filterMeta: FilterMetadata;
    disabled?: boolean;
}
export function PercentValueInput(props: Props) {
    const { disabled, filterMeta } = props;
    const placeholder = filterMeta.content.label;

    const [value, onChange] = useDebouncedState<number>({
        debounceTimeout: 800,
        value: props.value,
        onChange: props.onChange,
    });

    return (
        <div className="border-none relative rounded-md shadow-xs">
            <Input
                type="number"
                min={0}
                // className="pr-10 border-none block w-full rounded-md sm:text-sm text-right ring-1 ring-inset ring-slate-300 focus:outline-hidden focus:ring-2 focus:ring-blue-500"
                value={value * 100}
                placeholder={placeholder}
                onChange={(e) => {
                    if (!disabled) {
                        const updatedValue = Number(e.currentTarget.value);
                        onChange(updatedValue / 100);
                    }
                }}
            />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                <PercentIcon
                    className={cn("text-muted-foreground", {
                        "h-5 w-5": true,
                    })}
                />
            </div>
        </div>
    );
}
